import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ReportingDataService} from "../../services/reporting-data.service";

@Component({
  selector: 'app-sla-documentation',
  template: require('./sla-documentation.component.html'),
  styles: [require('./sla-documentation.component.sass')]
})
export class SlaDocumentationComponent implements OnInit {

  @ViewChild('slaDocumentationModal') slaDocumentationModal: ElementRef;

  slaDocumentationModalReference: NgbModalRef;
  @Input() markupPageSource: any;

  constructor(
      private modalService: NgbModal,
      private reportingDataService: ReportingDataService,
  ) { }

  ngOnInit(): void {
  }

  async showModal(projectId: number, fileName: string) {
    this.markupPageSource = await this.reportingDataService.getTripSlaDocumentation(projectId, fileName);
    this.slaDocumentationModalReference = await this.modalService.open(this.slaDocumentationModal, {
      backdrop: 'static',
      size: 'lg'
    });
  }

  cancel = () => {
    this.slaDocumentationModalReference.close();
  }

}
